module.exports = __webpack_public_path__ + "static/media/A7S01934.2abbd76f.jpg";